import { FieldEnum } from './sectionSchema';
import { useReferralFormContext } from '../ReferralFormContext';
import { SolutionAreasMap, SolutionAreasType } from './fixtures';
import { useEffect, useMemo } from 'react';
import { SectionSingleSelectField } from './SectionFields';

const solutionAreaOptions = Object.keys(SolutionAreasMap).map((x) => ({
  title: x,
  value: x,
}));

/**
 * TODO:
 *  - clear out the value of details.requirements.solutionPlay before changing the options
      to fix the controlled/uncontrolled error message in the console
 */
const SolutionAreasFields = () => {
  const { setValue, watch } = useReferralFormContext();
  const watchSolutionArea =
    (watch(FieldEnum.solutionArea) as SolutionAreasType) || '';

  useEffect(() => {
    setValue(FieldEnum.solutionPlay, '');
  }, [watchSolutionArea, setValue]);

  const solutionPlayOptions = useMemo(() => {
    if (!watchSolutionArea || !(watchSolutionArea in SolutionAreasMap))
      return [];
    return SolutionAreasMap[watchSolutionArea].map((x: string) => ({
      title: x,
      value: x,
    }));
  }, [watchSolutionArea]);

  return (
    <>
      <SectionSingleSelectField
        name={FieldEnum.solutionArea}
        options={solutionAreaOptions}
      />
      <SectionSingleSelectField
        disabled={!solutionPlayOptions?.length}
        name={FieldEnum.solutionPlay}
        options={solutionPlayOptions}
      />
    </>
  );
};

export default SolutionAreasFields;
